import React from "react";
import styled from "styled-components";

// Import logos
import vnips from "./assets/vnips.png";
import mindsbourg from "./assets/mindsbourg.png";
import nc from "./assets/logo.png";
import edhec from "./assets/edhec.png";
import enki from "./assets/enki.png";
import { useMediaQuery } from "@mantine/hooks";
import logoIcon from "./assets/logo3.png";
// Styled Components for Logo
const LogoContainer = styled.a`
  display: flex;
  gap: 5px;
  align-items: center;
  text-decoration: none;
  min-width: 0;
  flex-shrink: 0;
  
  @media (max-width: 834px) {
    gap: 3px;
  }
`;

const LogoImage = styled.img`
  height: ${({ height }) => height || "auto"};
  margin-bottom: 5px;
  margin-right: 5px;
  flex-shrink: 0;
  
  @media (max-width: 834px) {
    margin-bottom: 3px;
    margin-right: 3px;
  }
`;

const BetaTag = styled.div`
  background: #3d3b4b;
  padding: 2px 4px;
  border-radius: 5px;
  margin-top: 8px;
  color: var(--color-container-card-default);
  font-family: "Montserrat", sans-serif;
  font-weight: var(--font-weight-body-1);
  font-size: var(--font-size-body-4);
  height: fit-content;
  flex-shrink: 0;
  white-space: nowrap;
  
  @media (max-width: 834px) {
    margin-top: 6px;
    padding: 1px 3px;
    font-size: 10px;
    display: none;

  }
`;

const Logo = () => {
  const isMobile = useMediaQuery("(max-width: 834px)");
  const hostname = window.location.hostname;
  
  // Improved subdomain detection
  const getSubdomain = (hostname) => {
    const parts = hostname.split('.');
    // Check if it's a valid subdomain (not www and has more than 2 parts)
    if (parts.length > 2 && parts[0] !== 'www') {
      return parts[0];
    }
    return null;
  };

  const subdomain = getSubdomain(hostname);

  // Define logo mapping
  const logoMapping = {
    mindsbourg,
    vnips,
    edhec,
    default: nc,
    enki,
  };

  // Only render subdomain logo if it exists in the mapping
  const shouldRenderSubdomainLogo = subdomain && logoMapping[subdomain];

  return (
    <LogoContainer href="/dashboard/#/">
      {shouldRenderSubdomainLogo && (
        <LogoImage 
          src={logoMapping[subdomain]} 
          alt={`${subdomain} Logo`} 
          height="40px" 

        />
      )}
      <LogoImage src={ !isMobile? nc : logoIcon} alt="Logo" height="25px" />
      <BetaTag>Beta</BetaTag>
    </LogoContainer>
  );
};

export default Logo;